import { Component, Input, EventEmitter, Output } from '@angular/core';
import { NavParams } from 'ionic-angular/navigation/nav-params';
import moment from 'moment';
import { LoadingController, ModalController, Events } from 'ionic-angular';
import { ToastAlertsProvider } from '../../providers/toast-alerts/toast-alerts';
import { LoginProvider } from '../../providers/login/login';
import { AppState } from '../../config/state';
import { SoundsProvider } from '../../providers/sounds/sounds';
import { ReserveBlock } from '../../providers/config/config';
import { PatronProvider } from '../../providers/patron/patron';
import { CoLoginComponent } from '../co-login/co-login';
import { ClientDetailsProvider } from '../../providers/client-details/client-details';
import { InAppBrowser } from '@ionic-native/in-app-browser';

/**
 * Generated class for the CoReservationDetailsComponent component.
 *
 * See https://angular.io/api/core/Component for more info on Angular
 * Components.
 */
@Component({
  selector: 'co-reservation-details',
  templateUrl: 'co-reservation-details.html',
  inputs: ['item', 'clientKeyword', 'mode', 'isCostEnabled']
})
export class CoReservationDetailsComponent {
  item: any;
  @Input('clientKeyword') clientKeyword: string;
  @Input('barcode') barcode: string;
  @Input('mode') mode: string = 'multi';
  @Input('isCostEnabled') isCostEnabled;
  @Input('libraryCardRequired') libraryCardRequired;
  @Input('hideNotes') hideNotes: boolean;
  @Input('clientRoomSettings') clientRoomSettings: any;
  @Input('blockSettings') blockSettings: ReserveBlock;
  reservationLength: string;
  reservationLengthHour: number;
  totalCost: number;
  toggleNote: boolean = false;
  patronDetails: any;
  notFirstBookingPage: boolean = false;
  commonInfo: any;
  emailRegex: any;
  phoneRegex: any;
  inputsValid: boolean;
  validationObject: any = {email: true, phone: true}
  emailPlaceholder: string;
  phonePlaceholder: string;
  groupNamePlaceholder: string;
  bookingTitlePlaceholder: string;
  bookingTypes: any;
  isStaff: boolean = false;
  pinlessAuth: boolean;
  showAttendees: boolean = false;
  maxAttendees: number;
  minAttendees: number = 0;
  @Output() checkRequiredFields: EventEmitter<any> = new EventEmitter<any>();

  constructor(public navParams: NavParams, private loading: LoadingController, private toast : ToastAlertsProvider, private loginProvider: LoginProvider, private state: AppState, private sounds : SoundsProvider, private patronProvider : PatronProvider, private modalCtrl: ModalController, private events: Events, private _clientDetailsProvider: ClientDetailsProvider, private _inAppBrowser: InAppBrowser) {
    this.emailRegex = new RegExp('^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$');
    this.phoneRegex = new RegExp('^[^a-zA-Z]*$');
    this.isStaff = state.staff;
    this.pinlessAuth = this.state.client.settings.client_pinless_auth || false;
    this.showAttendees = this.state.showAttendees;
    this.getUserClasses();
  }

  ngAfterViewInit(): void {
    this.sounds.playSoundOnButtonClick();
	if(this.state.staff && this.barcode){
		  this.patronProvider.getSummaryDetails(this.barcode).then(details => {
			this.selectPatron(details);
		  });
	}
}
  getUserClasses() {
    if (this.isStaff) {
      this._clientDetailsProvider.userClasses().then((data) => {
        this.bookingTypes = data;
      }, (error) => {
        console.log("error getting user classes");
      });
    }
  }
  selectPatron(patron){
	this.item.personalInfo.firstName = patron.firstName;
	this.item.personalInfo.lastName = patron.lastName;
	this.item.personalInfo.email = patron.email;
	this.item.personalInfo.phone = patron.phone;
	this.item.personalInfo.libraryCard = patron.barcode;
  }
  initializeDetails(startTime, endTime, currentItem, index, commonInfo) {
    if (index > 0) {
      this.notFirstBookingPage = true;
    } else {
      this.notFirstBookingPage = false;
    }
    this.commonInfo = commonInfo;
    // console.log(this.clientRoomSettings, this.blockSettings)

    this.item = currentItem;
    this.checkRequiredFields.emit(this.item);

    if(this.blockSettings.settings?.['maxAttendees']) {
      this.maxAttendees = this.blockSettings.settings?.['maxAttendees'];
    } else if(this.item.chosenLayout && this.item.chosenLayout.capacity) {
      this.maxAttendees = this.item.chosenLayout.capacity;
    } else if(!this.state.staff) {
      this.maxAttendees = this.item.room.sizeAndCapacity.capacity;
    }

    if(this.blockSettings.settings?.['minAttendees']) {
      this.minAttendees = this.blockSettings.settings?.['minAttendees'];
    }

    if (!this.item.personalInfo) {
      this.item.personalInfo = { attendees: this.minAttendees || 0 };
    }

    if (this.item.personalInfo.noteToggle === undefined) {
      this.toggleNote = false;
    }
    else {
      this.toggleNote = this.item.personalInfo.noteToggle
    }

    if (!this.item.personalInfo.customQuestions) {
      this.item.personalInfo.customQuestions = [];
      if (this.item.room.customQuestions){
        for (let q of this.item.room.customQuestions) {
          this.item.personalInfo.customQuestions.push(null);
        }
      }
    }

    this.clientRoomSettings.rooms_require_email? this.emailPlaceholder = "Email *" : this.emailPlaceholder = "Email"
    this.clientRoomSettings.rooms_require_phone? this.phonePlaceholder = "Phone *" : this.phonePlaceholder = "Phone"
    this.groupNamePlaceholder = this.state.customStrings && this.state.customStrings.reserve && this.state.customStrings.reserve.groupNamePlaceholder ? this.state.customStrings.reserve.groupNamePlaceholder : "Group name *";
    this.bookingTitlePlaceholder = this.state.customStrings && this.state.customStrings.reserve && this.state.customStrings.reserve.bookingTitlePlaceholder ?  this.state.customStrings.reserve.bookingTitlePlaceholder : this.bookingTitlePlaceholder = "Booking title *";

    // this.fillInfoContainers(currentItem);
    this.buildReservationLengthString(startTime, endTime);
    this.calculateTotalCost(currentItem);

    if (this.state.patron && !this.state.staff && !this.patronDetails) {
      this.patronDetails = this.state.patron;
      this.fillInPatronInfo();
      this.fillBookingTitle();
    }
  }


  fillBookingTitle() {
    let firstNameInput, lastNameInput, finalString;
    firstNameInput = this.item.personalInfo.firstName;
    lastNameInput = this.item.personalInfo.lastName;
    // bookingTitleInput = document.querySelector("#bookingTitleInput");

    // bookingTitleInput.value = '';

    if (lastNameInput === '' || lastNameInput === undefined || lastNameInput === null) {
      finalString = firstNameInput;
    } else if (firstNameInput === '' || firstNameInput === undefined || firstNameInput === null)  {
      finalString = lastNameInput.toUpperCase().slice(0, 1) + '.';
    }
    else {
      finalString = `${firstNameInput} ${lastNameInput.toUpperCase().slice(0, 1)}.`;
    }

    // bookingTitleInput.value = finalString;
    this.item.personalInfo.bookingTitle = finalString;
    this.checkRequiredFields.emit(this.item);
  }

  buildReservationLengthString(startTime, endTime) {
    let hour, minute;

    hour = moment(endTime).diff(startTime, "hours");
    minute = moment(endTime).diff(startTime, "minutes");
    if (hour > 0) {
      minute = minute - (hour * 60);
    }

    let finalString: string = "";

    if (hour === 1) {
      finalString = "1 hour";
    }
    else if (hour > 1) {
      finalString = `${hour} hours`;
    }

    if (minute === 1) {
      if (finalString === "") {
        finalString = "1 minute";
      }
      else {
        finalString += " 1 minute";
      }
    }
    else if (minute > 1) {
      if (finalString === "") {
        finalString = `${minute} minutes`;
      }
      else {
        finalString += ` ${minute} minutes`;
      }
    }
    this.reservationLengthHour = hour;
    this.reservationLength = finalString;
  }

  calculateTotalCost(item) {
    let totalCost = 0;

    totalCost += item.assetTotalCost;
    totalCost += (10 * this.reservationLengthHour) + 10;

    this.totalCost = totalCost;
  }

  updateUserInfo(event, i?, forceId?, checkbox?) {
    let inputId = event.target.id;
    let inputValue = event.target.value;

    if (forceId) {
      inputId = forceId;
    }

    if (inputValue === '') {
      inputValue = null;
    }
    if (i === undefined || typeof i === "string") {
      switch (inputId) {
        case "libraryCardInput":
          this.item.personalInfo.libraryCard = inputValue;
          this.item.detailsRetrieved = false;
          break;
        case "pinInput":
          this.item.personalInfo.pin = inputValue;
          this.item.detailsRetrieved = false;
          break;
        case "firstNameInput":
          this.item.personalInfo.firstName = inputValue;
          break;
        case "lastNameInput":
          this.item.personalInfo.lastName = inputValue;
          break;
        case "emailInput":
          this.item.personalInfo.email = inputValue;
          break;
        case "phoneInput":
          this.item.personalInfo.phone = inputValue;
          break;
        case "groupNameInput":
          this.item.personalInfo.groupName = inputValue;
          break;
        case "bookingTitleInput":
          this.item.personalInfo.bookingTitle = inputValue;
          break;
        case "attendeesInput":
          if(this.maxAttendees) {
            const attendees = Math.min(inputValue, this.maxAttendees);
            this.item.personalInfo.attendees = attendees;
            event.target.value = attendees;
          } else {
            this.item.personalInfo.attendees = inputValue;
          }
          break;
        case "noteInput":
          this.item.personalInfo.note = inputValue;
          break;
        case "noteToggle":
          if (this.item.personalInfo.noteToggle === undefined) {
            this.item.personalInfo.noteToggle = false;
          }
          this.toggleNote = !this.toggleNote;
          this.item.personalInfo.noteToggle = this.toggleNote;
          break;
        default:
          console.log("couldn't find id to input, try adding it to code", inputId);
      }
    } else {
      // this.item.personalInfo.customQuestions[i] = null;
      if (checkbox) {
        // if (this.item.personalInfo.customQuestions[i]) {
          //   this.item.personalInfo.customQuestions[i] = null;
          //   console.log('checkbox set to null');
          // }
          // else {
            if (this.item.personalInfo.customQuestions[i] === null) {
              this.item.personalInfo.customQuestions[i] = true;
            } else if (this.item.personalInfo.customQuestions[i] === true) {
              this.item.personalInfo.customQuestions[i] = null;
            }
        // }
      }
      else {
        this.item.personalInfo.customQuestions[i] = inputValue;
      }
    }
    if (this.notFirstBookingPage) {
      this.item.personalInfo.firstName = this.commonInfo.firstName;
      this.item.personalInfo.lastName = this.commonInfo.lastName;
      this.item.personalInfo.email = this.commonInfo.email;
      this.commonInfo.phone ? this.item.personalInfo.phone = this.commonInfo.phone : null;
      this.commonInfo.libraryCard ? this.item.personalInfo.libraryCard = this.commonInfo.libraryCard : null;
      this.commonInfo.pin ? this.item.personalInfo.pin = this.commonInfo.pin : null;
    }

      this.checkRequiredFields.emit(this.item);
  }

  formValidationFromCart(object){
    this.validationObject.email = object.email;
    this.validationObject.phone = object.phone;
  }

  async lookUpPatronDetails() {
    let libraryCardNumber, libraryCardPin;

    if (this.item.personalInfo.libraryCard && (this.item.personalInfo.pin || this.pinlessAuth || this.state.staff)) {
      libraryCardNumber = this.item.personalInfo.libraryCard;
      libraryCardPin = this.item.personalInfo.pin;
    }
    else {
      console.log('Please fill out both fields');
      return;
    }

    let loader = this.loading.create({content: "Retreiving details..."});
    loader.present();
    await this.patronProvider.getSummaryDetails(libraryCardNumber, libraryCardPin).then((res) => {
      if (res && res.id != null) {
        if (!this.state.sharedScreen || this.state.staff) {
          this.loginProvider.login(res.barcode, libraryCardPin);
        }
        if ((this.state.currentScreen && this.state.currentScreen.settings && this.state.currentScreen.settings.preventPatronLogin)||this.state.sharedScreen||this.state.staff){

        } else {
          this.toast.triggerToast('You are now logged in','','success', 5000);
        }
        this.patronDetails = res;
        this.item.personalInfo.firstName = this.patronDetails.firstName;
        this.item.personalInfo.lastName = this.patronDetails.lastName;
        this.item.personalInfo.email = this.patronDetails.email;
        if(this.patronDetails.phone) this.item.personalInfo.phone = this.patronDetails.phone;
        this.fillBookingTitle();
        this.item.detailsRetrieved = true;
        this.checkRequiredFields.emit(this.item);
      } else {
        this.toast.triggerToast("Incorrect Information", '');
      }
    }).catch((err) => {
      this.toast.triggerToast("Incorrect Information", '');
    });;

    loader.dismiss().catch(err=>{});

  }

  fillInPatronInfo() {
    if (!this.item.personalInfo) {
      this.item.personalInfo = { attendees: this.minAttendees || 0 };
    }
    this.item.personalInfo.libraryCard = this.patronDetails.barcode;
    this.item.personalInfo.pin = this.patronDetails.pin;
    this.item.personalInfo.firstName = this.patronDetails.firstName;
    this.item.personalInfo.lastName = this.patronDetails.lastName;
    this.item.personalInfo.email = this.patronDetails.email;
    this.item.personalInfo.phone = this.patronDetails.phone || '';
    this.item.detailsRetrieved = true;
    this.checkRequiredFields.emit(this.item);
  }

  openLink(url) {
    this._inAppBrowser.create(url, "_system");
  }
}



// WEBPACK FOOTER //
// ./src/components/co-reservation-details/co-reservation-details.ts